import { Resources } from 'constants/resources';
import { SECURITY_ISSUES, SECURITY_ISSUES_SELECT_ITEMS } from 'constants/securityIssues';

import { ACCESS_SELECT_ITEMS, ACCESS_TITLES } from 'pages/ApiClients/constants/accessSelectItems';
import { ACTIVITY_BOOLEAN_CHOICES } from 'pages/ApiClients/constants/activityBooleanChoices';
import { required } from 'react-admin';
import { FilterFieldConfig } from 'shared/mui/Filter/config';
import { AutocompleteInput, SelectInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

export const useApiClientsListFilterFields = (): FilterFieldConfig[] => [
  {
    name: 'name',
    label: 'Название',
    chipType: 'text',
    input: (
      <TextInput
        helperText={false}
        key="name"
        label="Название"
        resettable
        source="name"
        variant="outlined"
      />
    ),
  },
  {
    name: 'active',
    label: 'Активность',
    chipType: 'text',
    chipProps: {
      getName: (filterValue: string) =>
        ACTIVITY_BOOLEAN_CHOICES.find((value) => value.id === filterValue)?.name as string,
      isNotIgnoreFalseValue: true,
    },
    input: (
      <SelectInput
        choices={ACTIVITY_BOOLEAN_CHOICES}
        fullWidth
        helperText={false}
        label="Активность"
        name="active"
        source="active"
        validate={required()}
        variant="outlined"
      />
    ),
  },
  {
    name: 'roles',
    label: 'Доступ',
    chipType: 'text',
    chipProps: {
      getName: (filterValue: keyof typeof ACCESS_TITLES) => ACCESS_TITLES[filterValue],
    },
    input: (
      <SelectInput
        choices={ACCESS_SELECT_ITEMS}
        defaultValue={null}
        fullWidth
        helperText={false}
        id="roles"
        label="Доступ"
        name="roles"
        optionText="label"
        source="roles"
        variant="outlined"
      />
    ),
  },
  {
    name: 'merchants',
    label: 'Мерчант',
    chipType: 'autocomplete',
    chipProps: {
      resource: Resources.Merchants,
    },
    input: (
      <ReferenceInput perPage={200} reference={Resources.Merchants} source="merchants">
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label="Мерчант"
          optionText="name"
          size="small"
          variant="outlined"
        />
      </ReferenceInput>
    ),
  },
  {
    name: 'securityIssues',
    label: 'Уведомление безопасности',
    chipType: 'text',
    chipProps: {
      getName: (filterValue: keyof typeof SECURITY_ISSUES) => SECURITY_ISSUES[filterValue]?.title,
    },
    input: (
      <SelectInput
        choices={SECURITY_ISSUES_SELECT_ITEMS}
        defaultValue={null}
        fullWidth
        helperText={false}
        id="securityIssues"
        label="Уведомление безопасности"
        name="securityIssues"
        source="securityIssues"
        variant="outlined"
      />
    ),
  },
];
